import EmployeePayDistributionPage from "./EmployeePayDistributionPage";

export default EmployeePayDistributionPage;
